import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import { Text } from '@olist/united';

import { Image } from '@common/components/Image';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: space-evenly;

  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.small}) {
          flex-direction: column;
      `
    );
  }}
`;

const ContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-width: 50%;
  padding: ${themeGet('olist.spacing.stack.small')};
`;

export const LogoContainer = styled(ContentContainer)`
  align-items: flex-start;
  background-color: ${themeGet('olist.color.neutral.stronger')};
  background-image: url('https://images.ctfassets.net/l4r9zb8wkhs5/Rc5nwLIio2ZdtKpTEDdtR/5a5430126457ebc4128b037bf0fd9f4c/image__5_.png');
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: flex-start;
  width: 100%;
`;

export const FormContainer = styled(ContentContainer)``;

export const FormWrapper = styled.div`
  max-width: 432px;

  label {
    line-height: 2;
  }
`;

export const LogoContentWrapper = styled.div``;

export const ImagesWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const MainLogo = styled(Image)`
  height: 40px;
  left: 100px;
  position: relative;
  top: 100px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.small}) {
          left: 16px;
          top: 16px;
        }
      `
    );
  }}
`;

export const AltLogo = styled(Image)`
  background-color: ${themeGet('olist.color.neutral.softest')};
  border-radius: 50%;
  height: 49px;
  padding: 6px;
  width: 49px;
`;

export const Subtitle = styled(Text.H3)`
  color: ${themeGet('olist.color.neutral.stronger')};
  left: 100px;
  margin-bottom: 75px;
  padding-left: 5px;
  position: relative;
  top: 110px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.small}) {
          left: 16px;
          top: 16px;
        }
      `
    );
  }}
`;

export const Title = styled(Text.H3)`
  font-weight: ${themeGet('olist.fontWeight.bold')};
  margin-bottom: ${themeGet('olist.spacing.stack.small')};
`;

export const DescriptionText = styled(Text.H4)`
  color: ${themeGet('olist.color.neutral.stronger')};
  margin-bottom: ${themeGet('olist.spacing.stack.small')};
  small {
    display: block;
    font-size: 80%;
    margin-top: 10px;
  }
`;

export const ErrorContainer = styled(Text)`
  align-items: center;
  color: ${themeGet('olist.color.alert.base')};
  display: flex;
  font-weight: ${themeGet('olist.fontWeight.semibold')};
  margin-bottom: ${themeGet('olist.spacing.stack.small')};
  margin-top: ${themeGet('olist.spacing.stack.small')};

  svg {
    margin-right: ${({ theme }) => theme.olist.spacing.stack['1xsmall']};
  }
`;

export const SubmitContainer = styled(Text)`
  margin-top: ${themeGet('olist.spacing.stack.large')};
  width: 100%;
`;
